import {createSlice} from "@reduxjs/toolkit";

const defaultSettings = {
    categories: [],
    mydata: [],
}

export const defaultFixedAssetsSettingCategory = {
    name: "",
    startingPeriod: "nextMonth",
    vatIsIncluded: false,
    percentageTable: [],
    maskCode: "",
    maskCodeCounter: 1,
}

export const defaultFixedAssetsSettingPercTable = {
    percentage: 0,
    monthFrom: 0,
    monthTo: 0,
    amountFrom: 0,
    amountTo: 0,
}

export const defaultNewFixedAssetPercTable = {
    percentage: 0,
    monthFrom: "",
    monthTo: "",
}

export const defaultEditFixedAssetAdditionalImprovement = {
    type: "addition",
    date: Date.now(),
    description: "",
    correlatedBuy: "",
    correlatedBuyLabel: "",
    correlatedBuyRowNumber: "",
    amount: 0,
    vatIncluded: false,
}

export const defaultNewFixedAsset = {
    name: "",
    category: "",
    dateFrom: Date.now(),
    vatIsIncluded: false,
    quantity: 1,
    acquisitionCost: 0,
    accumulatedDepreciation: 0,
    percentageTable: [],
    mydata: [],
    accounting: "",
    bypassAccounting: "",
    inverseAccounting: "",
    bypassInverseAccounting: "",
    //accounting Sales
    accountingCodeSales: "",
    netAmountAccountingCodeSales: "",
    vatAccountingCodeSales: "",
    taxAccountCodeSales: "",
    //accounting Buys
    accountingCodeBuys: "",
    netAmountAccountingCodeBuys: "",
    vatAccountingCodeBuys: "",
    taxAccountCodeBuys: "",
    installation: "0",
}

const defaultNewFixedAssetMovement = {
    documentType: "",
    documentTypeName: "",
    number: "",
    date: Date.now(),
    reason: "",
    sum: 0,
    notes: "",
    installation: "0",
    preNumber: "",
    year: "",
    isCensus: "",
    fixedAssets: [],
}

export const defaultNewFixedAssetRecord = {
    documentType: "",
    documentTypeName: "",
    number: "",
    date: Date.now(),
    dateTo: Date.now(),
    installation: "0",
    preNumber: "",
    year: "",
    fixedAssets: [],
    notes: "",
}

const initFixedAssetMovementsReportRequestData = {
    page: 1,
    date_from: "",
    date_to: "",
    name: "",
    code: "",
    installation: "",
    include_zero_balance: false,
}

const initFixedAssetMovementsReportResponseData = {
    data: [],
    totalPages: 0,
    fixedAsset: null,
}

const initFixedAssetBookReportRequestData = {
    page: 1,
    date_to: "",
    generalFilter: "",
    acquisitionCost_from: "",
    acquisitionCost_to: "",
    include_zero_balance: false,
    include_buys: false,
}

const initFixedAssetBookReportResponseData = {
    data: [],
    totalPages: 0,
    totals: {
        acquisitionCost: 0,
        accumulatedDepreciation: 0,
        balance: 0,
    }
}

const initFixedAssetSoldReportRequestData = {
    page: 1,
    date_from: "",
    date_to: "",
    generalFilter: "",
    acquisitionCost_from: "",
    acquisitionCost_to: "",
}

const initFixedAssetSoldReportResponseData = {
    data: [],
    totalPages: 0,
    totals: {
        totalBought: 0,
        totalSold: 0,
        totalAccDep: 0,
        totalProfit: 0,
    }
}

const initialState = {
    fixedAssetsSettings: defaultSettings,
    fixedAssetsSettingsSelectedCategory: -1, // index
    newFixedAsset: {...defaultNewFixedAsset},
    editFixedAsset: {...defaultNewFixedAsset},
    newFixedAssetMovement: {...defaultNewFixedAssetMovement},
    editFixedAssetMovement: {...defaultNewFixedAssetMovement},
    newFixedAssetRecord: {...defaultNewFixedAssetRecord},
    newFixedAssetRecordAutomatedData: {}, // Autofill when from sale
    editFixedAssetRecord: {...defaultNewFixedAssetRecord},

    searchFixedAssets: [],
    totalItemsFA: 0,
    perPageFA: 0,

    searchFixedAssetMovements: [],
    totalItemsFAM: 0,
    perPageFAM: 0,

    searchFixedAssetRecords: [],
    totalItemsFAR: 0,
    perPageFAR: 0,

    // Report Fixed Asset Movements
    fixedAssetMovementsReportAutoLoad: "",
    fixedAssetMovementsReportRequestData: {},
    fixedAssetMovementsReportResponseData: {},

    // Report Fixed Asset Book
    fixedAssetBookReportRequestData: {},
    fixedAssetBookReportResponseData: {},

    // Report Sold Fixed Assets
    fixedAssetSoldReportRequestData: {},
    fixedAssetSoldReportResponseData: {},
}

export const FixedAssetsSlice = createSlice({
    name: "fixed-assets-slice",
    initialState,
    reducers: {
        setFixedAssetsSettings: (state, {payload}) => {
            state.fixedAssetsSettings = payload;
        },
        setFixedAssetsSettingsSelectedCategory : (state, {payload}) => {
            state.fixedAssetsSettingsSelectedCategory = payload;
        },

        // Fixed Assets
        setNewFixedAsset: (state, {payload}) => {
            state.newFixedAsset = payload;
        },
        resetNewFixedAsset: (state) => {
            state.newFixedAsset = {...defaultNewFixedAsset};
        },
        setEditFixedAsset: (state, {payload}) => {
            state.editFixedAsset = payload;
        },
        setSearchFixedAssets: (state, {payload}) => {
            state.searchFixedAssets = payload;
        },
        setSearchFixedAssetsTotalItems: (state, {payload}) => {
            state.totalItemsFA = payload;
        },
        setSearchFixedAssetsPerPage: (state, {payload}) => {
            state.perPageFA = payload;
        },

        // Fixed Asset Movements
        setNewFixedAssetMovement: (state, {payload}) => {
            state.newFixedAssetMovement = payload;
        },
        resetNewFixedAssetMovement: (state) => {
            state.newFixedAssetMovement = {...defaultNewFixedAssetMovement};
        },
        setEditFixedAssetMovement: (state, {payload}) => {
            state.editFixedAssetMovement = payload;
        },
        setSearchFixedAssetMovements: (state, {payload}) => {
            state.searchFixedAssetMovements = payload;
        },
        setSearchFixedAssetMovementsTotalItems: (state, {payload}) => {
            state.totalItemsFAM = payload;
        },
        setSearchFixedAssetMovementsPerPage: (state, {payload}) => {
            state.perPageFAM = payload;
        },

        // Fixed Asset Records
        setNewFixedAssetRecord: (state, {payload}) => {
            state.newFixedAssetRecord = payload;
        },
        resetNewFixedAssetRecord: (state) => {
            state.newFixedAssetRecord = {...defaultNewFixedAssetRecord};
        },
        setEditFixedAssetRecord: (state, {payload}) => {
            state.editFixedAssetRecord = payload;
        },
        setSearchFixedAssetRecords: (state, {payload}) => {
            state.searchFixedAssetRecords = payload;
        },
        setSearchFixedAssetRecordsTotalItems: (state, {payload}) => {
            state.totalItemsFAR = payload;
        },
        setSearchFixedAssetRecordsPerPage: (state, {payload}) => {
            state.perPageFAR = payload;
        },
        setNewFixedAssetRecordAutomatedData: (state, {payload}) => {
            state.newFixedAssetRecordAutomatedData = payload;
        },

        // Report Fixed Asset Movements
        initFixedAssetMovementsReport: (state, {payload}) => {
            state.fixedAssetMovementsReportRequestData[payload.tabKey] = {...initFixedAssetMovementsReportRequestData};
            state.fixedAssetMovementsReportResponseData[payload.tabKey] = {...initFixedAssetMovementsReportResponseData};
        },
        setFixedAssetMovementsReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.fixedAssetMovementsReportRequestData[tabKey] = action.payload;
        },
        setFixedAssetMovementsReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.fixedAssetMovementsReportResponseData[tabKey] = action.payload;
        },
        setFixedAssetMovementsReportAutoLoad: (state, {payload}) => {
            state.fixedAssetMovementsReportAutoLoad = payload;
        },

        // Report Fixed Asset Book
        initFixedAssetBookReport: (state, {payload}) => {
            state.fixedAssetBookReportRequestData[payload.tabKey] = {...initFixedAssetBookReportRequestData};
            state.fixedAssetBookReportResponseData[payload.tabKey] = {...initFixedAssetBookReportResponseData};
        },
        setFixedAssetBookReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.fixedAssetBookReportRequestData[tabKey] = action.payload;
        },
        setFixedAssetBookReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.fixedAssetBookReportResponseData[tabKey] = action.payload;
        },

        // Report Sold Fixed Assets
        initFixedAssetSoldReport: (state, {payload}) => {
            state.fixedAssetSoldReportRequestData[payload.tabKey] = {...initFixedAssetSoldReportRequestData};
            state.fixedAssetSoldReportResponseData[payload.tabKey] = {...initFixedAssetSoldReportResponseData};
        },
        setFixedAssetSoldReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.fixedAssetSoldReportRequestData[tabKey] = action.payload;
        },
        setFixedAssetSoldReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.fixedAssetSoldReportResponseData[tabKey] = action.payload;
        },
    }
});

export const {
    setFixedAssetsSettings,
    setFixedAssetsSettingsSelectedCategory,

    // Fixed Assets
    setNewFixedAsset,
    resetNewFixedAsset,
    setEditFixedAsset,
    setSearchFixedAssets,
    setSearchFixedAssetsTotalItems,
    setSearchFixedAssetsPerPage,

    // Fixed Asset Movements
    setNewFixedAssetMovement,
    resetNewFixedAssetMovement,
    setEditFixedAssetMovement,
    setSearchFixedAssetMovements,
    setSearchFixedAssetMovementsTotalItems,
    setSearchFixedAssetMovementsPerPage,

    // Fixed Asset Records
    setNewFixedAssetRecord,
    resetNewFixedAssetRecord,
    setEditFixedAssetRecord,
    setSearchFixedAssetRecords,
    setSearchFixedAssetRecordsTotalItems,
    setSearchFixedAssetRecordsPerPage,
    setNewFixedAssetRecordAutomatedData,

    // Report Fixed Asset Movements
    initFixedAssetMovementsReport,
    setFixedAssetMovementsReportRequestData,
    setFixedAssetMovementsReportResponseData,
    setFixedAssetMovementsReportAutoLoad,

    // Report Fixed Asset Book
    initFixedAssetBookReport,
    setFixedAssetBookReportRequestData,
    setFixedAssetBookReportResponseData,

    // Report Sold Fixed Assets
    initFixedAssetSoldReport,
    setFixedAssetSoldReportRequestData,
    setFixedAssetSoldReportResponseData,
} = FixedAssetsSlice.actions;